<template>
  <NuxtLayout name="markup">
    <MarkupGenerator :page-data="markupData || undefined" :is-page="true" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { general_setPageTheme } from '~/utils/general/pageThemeClassFromMarkup';
import { ASYNC_KEY_PHONE_LISTING } from '~/models/AsyncDataKeys.model';

const config = useRuntimeConfig();
const route = useRoute();
definePageMeta({
  layout: false,
});

const notificationStore = useNotificationStore();
notificationStore.reset();

const { $api } = useNuxtApp();

const { data: markupData, error } = await useAsyncData(
  ASYNC_KEY_PHONE_LISTING,
  async () => {
    return await $api.categoryModule.getCategory(1);
  },
  {
    transform: cache_addFetchedAtTransform,
    getCachedData: cache_getCachedDataFromServer,
  },
);

if (error.value) {
  if (import.meta.client) {
    console.log(error.value);
  }
  notificationStore.setStandardErrorNotification();
}
const canonicalUrl = `${config.public.apiBaseUrl.replace(/\/$/, '')}${route.fullPath.split('?')[0]}`;

filters_initializeFiltersIfListComponentExists(markupData.value, false);
general_setPageTheme(markupData.value?.PageContent);

const seoInput = {
  seoData: {
    title: markupData?.value?.MetaTitle,
    description: markupData?.value?.MetaDescription,
    siteName: 'Halebop',
    keywords: markupData?.value?.MetaKeywords,
    canonicalUrl,
  },
  fallBackSeoData: {
    title: 'Köp ny mobil med 5G abonnemang | Halebop | Halebop.se',
    description:
      'Utforska mobiltelefoner hos Halebop Shop. Köp den senaste mobilen med abonnemang för dina behov. Ett brett utbud för dig!',
    siteName: 'Halebop',
    keywords: '',
    canonicalUrl,
  },
};
useCustomSeoMeta(seoInput);
</script>
